<template>
  <!-- <div style="padding:42.86% 0 0 0;position:relative;"> -->
  <div style="padding:51% 0 0 0;position:relative;height:100%">
    <iframe
      :src="url"
      style="position:absolute;top:0;left:0;width:100%;height:100%;"
      frameborder="0"
      allow="xr-spatial-tracking; autoplay; fullscreen; picture-in-picture; gyroscope;accelerometer"
      allowfullscreen
    />
    <snackbar :message="snackbarErrorMessage" />
  </div>
</template>

<script>
import { getLearningObjectWithContents } from '@/services/graphql/customQueries';
import gql from 'graphql-tag';
import Snackbar from '@/components/desktop/Snackbar.vue';

export default {
  name: 'Simulator',
  components: {
    Snackbar,
  },
  data: () => ({
    learningObject: {},
    contents: [],
    url: '',
  }),
  apollo: {
    learningObject: {
      query: gql(getLearningObjectWithContents),
      variables() {
        return { id: this.$route.params.id };
      },
      update: (data) => data.getLearningObject,
      error(error) {
        this.$store.commit('showErrorMessage', {
          message: `Não foi possível carregar o Objeto de Aprendizagem! ${error}`,
        });
      },
    },
  },
  watch: {
    learningObject(lo) {
      if (!lo) return;
      this.contents = lo.sortedContentIds.map((id) => {
        return lo.contents.items.find((content) => content.id === id);
      });
      this.loadContent();
    },
    '$route.params.id': function (id) {
      // no-op, should only run the apollo query automatically
    },
  },
  methods: {
    loadContent() {
      if (!this.contents.length
        || !this.contents[0]) return;
      const firstContent = this.contents[0];
      // Get 3dvista url (CloudFront's CDN url)
      this.url = firstContent.content.url;
    },
  },
};
</script>
